/**
 * The rule for a password someone chooses, the same as the server's (security/PasswordPolicy.java), so people see what is
 * needed before they submit. The server has the last word, and also refuses well-known passwords and ones built from the email.
 */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_RULE = `At least ${PASSWORD_MIN_LENGTH} characters with a capital letter, a small letter and a number.`;

/** Each requirement and whether the password meets it: [{ label, met }]. */
export function passwordChecks(password) {
  const p = (password || '').trim();
  return [
    { label: `${PASSWORD_MIN_LENGTH} or more characters`, met: p.length >= PASSWORD_MIN_LENGTH },
    { label: 'a capital letter', met: /[A-Z]/.test(p) },
    { label: 'a small letter', met: /[a-z]/.test(p) },
    { label: 'a number', met: /[0-9]/.test(p) },
  ];
}

/** The message to show when the password is not good enough, or null when it is. */
export function passwordProblem(password) {
  return passwordChecks(password).every((c) => c.met) ? null : `Password must be at least ${PASSWORD_MIN_LENGTH} characters with a capital letter, a small letter and a number.`;
}
